import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SignIn } from './pages/SignIn';
import { PrivateRoute } from './PrivateRoute';
import { PrivateRouteLayout } from 'PrivateRouteLayout';

export const App = () => {
  return (
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <PrivateRouteLayout />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
